import axios, { AxiosError } from 'axios';
import { ROUTES } from 'routes';
// import { usePrivy } from '@privy-io/react-auth';

const HOST = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const privateApi = axios.create({
  baseURL: `${HOST}/api/v1`,
  headers,
  // withCredentials: true,
});

privateApi.interceptors.request.use(function (config) {
  try {
    // Ensure correct headers when sending FormData: let the browser set the multipart boundary
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      // Axios v1 may use AxiosHeaders; use delete if available, else fallback
      const hdrs: any = config.headers as any;
      if (hdrs) {
        if (typeof hdrs.delete === 'function') {
          hdrs.delete('Content-Type');
        } else if (hdrs['Content-Type']) {
          delete hdrs['Content-Type'];
        }
      }
    }

    const privyIdToken = localStorage.getItem('privy:id_token');
    if (privyIdToken) {
      // console.log('privyIdToken--', JSON.parse(privyIdToken));
      config.headers.Authorization = 'Bearer ' + JSON.parse(privyIdToken);
    }
    return config;
  } catch (error) {
    console.warn('Failed to retrieve and set token on Axios Headers:', error);
    return Promise.reject(error);
  }
});

privateApi.interceptors.response.use(
  (res) => res,
  async function (res: AxiosError) {
    const { response } = res;
    // const { logout } = usePrivy();

    if (response?.status === 401) {
      // logout()
      if (
        typeof window !== 'undefined' &&
        window.location.pathname !== ROUTES.LANDING &&
        window.location.pathname !== ROUTES.ONBOARDING &&
        window.location.pathname !== ROUTES.LOGIN
      ) {
        // TODO: we can add "from" query parameter to
        // back from index & login pages if authorized
        // window.location.reload();
        window.location.href = '/login';
      }
    }

    return Promise.reject(res);
  }
);

const publicAPi = axios.create({
  baseURL: `${HOST}/public`,
  headers,
});

export { privateApi, publicAPi };
